import { InputLabel, MenuItem } from "@mui/material";
import { NumberTypeSelectorProps } from "pages/vehicleregistry/pages/checks/UpcomingChecksTab/UpcomingChecksTab.interfaces";
import { StyledTableColumnSelect, StyledTableFormControl } from "shared/styled/General";

export const NumberTypeSelector = ({
    value,
    onChange,
    options,
    label,
    maxWidth = 150,
}: NumberTypeSelectorProps) => {
    const handleChange = (event: any) => {
        onChange(event.target.value);
    };

    return (
        <StyledTableFormControl size="small" sx={{ maxWidth }}>
            <InputLabel id="dynamic-select-label">
                {label}
            </InputLabel>

            <StyledTableColumnSelect
                labelId="dynamic-select-label"
                autoWidth
                value={value}
                label={label}
                onChange={handleChange}
            >
                {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </StyledTableColumnSelect>
        </StyledTableFormControl>
    );
};
